import React from 'react';


const VettingPlainTick = (props) => {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.0639 5.94141L11.0052 16.0002L6.53516 11.5289"  stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.1629 9.48519C22.4078 14.0164 20.1529 18.7769 15.8583 20.6842C11.5637 22.5915 6.51996 21.0725 3.99295 17.1108C1.46593 13.149 2.21502 7.93501 5.75517 4.84492C9.29532 1.75484 14.5627 1.71723 18.1466 4.75644"  stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default VettingPlainTick;